import { Fragment, h, render } from "preact";
import { useEffect, useState, useRef } from "preact/hooks";
import ProductBundleVariantContent from "./product-bundle-variant-content.jsx";
import storefront from "../helpers/storefront";
import * as queries from "../helpers/storefront/queries";

const BundlePickerContent = ({ data, form, group, bundle, parent = null }) => {
  const dataContainer = parent?.closest("[data-related-bundle]")
    ?.previousSibling?.previousSibling;
  const [selectedVariants, setSelectedVariants] = useState({});
  const [bundleProducts, setBundleProducts] = useState();

  useEffect(() => {
    const getData = async () => {
      if (bundle) setBundleProducts(bundle);
      if (dataContainer) {
        let data = JSON.parse(dataContainer.textContent);
        const response = await storefront.request({
          query: queries.products,
          variables: {
            ids: data.productsBundle.map((item) =>
              encodeId(item.id, "Product"),
            ),
          },
        });
        if (response?.data?.nodes) setBundleProducts(response.data.nodes);
      }
    };
    getData();
  }, []);

  return (
    <Fragment>
      <div className="product-bundle__content-title copy-text">
        Included in this Bundle:
      </div>
      {bundleProducts?.map((product, index) => (
        <ProductBundleVariantContent
          data={data}
          product={product}
          form={form}
          key={product.id}
        />
      ))}
    </Fragment>
  );
};

export default BundlePickerContent;
